var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7071_51339)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3C4048",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4471 15.9994C12.4471 15.0216 11.6471 14.2216 10.6694 14.2216C9.69164 14.2216 8.89166 15.0216 8.89166 15.9994C8.89166 16.9772 9.69164 17.7772 10.6694 17.7772C11.6471 17.7772 12.4471 16.9772 12.4471 15.9994ZM14.225 15.9996C14.225 16.9773 15.025 17.7773 16.0028 17.7773C16.9805 17.7773 17.7805 16.9773 17.7805 15.9996C17.7805 15.0218 16.9805 14.2218 16.0028 14.2218C15.025 14.2218 14.225 15.0218 14.225 15.9996ZM21.3361 17.7773C20.3583 17.7773 19.5583 16.9773 19.5583 15.9996C19.5583 15.0218 20.3583 14.2218 21.3361 14.2218C22.3139 14.2218 23.1139 15.0218 23.1139 15.9996C23.1139 16.9773 22.3139 17.7773 21.3361 17.7773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7071_51339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.a41327ed.svg";
export { ForwardRef as ReactComponent };